namespace Matrix.Rebalancer {
    export interface PluginForm {
        PluginName: Serenity.StringEditor;
        SupportedLang: Serenity.EnumEditor;
        ProgrammingLanguage: Serenity.StringEditor;
        ClassName: Serenity.StringEditor;
        TypeCode: Serenity.LookupEditor;
        Description: Serenity.StringEditor;
        PluginEnabled: Serenity.BooleanEditor;
        SourceCode: CodeEditor;
        Version: StaticTextBlock;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
    }

    export class PluginForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.Plugin';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PluginForm.init)  {
                PluginForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.LookupEditor;
                var w3 = s.BooleanEditor;
                var w4 = CodeEditor;
                var w5 = StaticTextBlock;
                var w6 = ReadOnlyDateTime;

                Q.initFormType(PluginForm, [
                    'PluginName', w0,
                    'SupportedLang', w1,
                    'ProgrammingLanguage', w0,
                    'ClassName', w0,
                    'TypeCode', w2,
                    'Description', w0,
                    'PluginEnabled', w3,
                    'SourceCode', w4,
                    'Version', w5,
                    'CreatedBy', w5,
                    'CreatedWhen', w6,
                    'UpdatedBy', w5,
                    'UpdatedWhen', w6
                ]);
            }
        }
    }
}
